export default {
    nl: {
        intro: {
            subtitle: 'Strategiesessie',
            title: 'Bodempje leggen.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/strategy-session/hero.webp',
        },
        type: 'Strategiesessie',
        title: 'Strategiesessie: Van online ambities tot concrete doelen',
        description:
            'Met strategiesessies verkennen we je online ambities. Van diepe analyses tot heldere roadmaps, voor optimale digitale aanwezigheid.',
        content: [
            {
                type: 'text',
                title: 'Strategiesessie',
                content:
                    'Bij het realiseren van nieuwe of bestaande producten gaan we bij 23G grondig te werk om de strategie en doelen helder te krijgen. We houden er niet van om klakkeloos te beginnen. Voordat we aan een project starten, willen we graag weten wat onze klanten willen bereiken met het product en wie de doelgroep van het product is. Geen klant en geen vraag is hetzelfde. Daarom denken we graag met je mee en nemen een adviserende rol aan in de digitale wereld. Hierbij duiken we niet alleen in de strategische kant, maar bekijken ook hoe we op het gebied van visual design / branding en UI/UX-design aspecten kunnen optimaliseren om jouw doelen te bereiken.',
            },
            {
                type: 'images',
                images: [
                    'https://23g-website.s3.eu-central-1.amazonaws.com/services/meeting-strategy-session.webp',
                ],
            },
            {
                type: 'text',
                title: 'Diepgaande strategiesessies',
                content:
                    'Tijdens onze strategiesessies verkennen we samen je online ambities. Bij bestaande producten duiken we er diep in om te begrijpen wat er al goed gaat en waar kansen liggen. Voor nieuwe projecten bieden we maatwerk in de vorm van een Design Sprint. Met de verzamelde inzichten stellen we vervolgens samen heldere doelen op en traceren we de route met een duidelijke roadmap. Naast de Design Sprint maken we gebruik van wireframing en prototyping, om ervoor te zorgen dat het ontwikkelde product naadloos aansluit op de behoeften van de doelgroep.',
            },
            {
                type: 'quote',
                content: 'Tijdens onze strategiesessies verkennen we samen je online ambities.',
            },
            {
                type: 'text',
                title: 'Jouw succes in de digitale arena',
                content:
                    "Wij helpen jouw merk te laten floreren in het digitale landschap. Of je nu op zoek bent naar meer websitebezoekers, hogere conversieratio's, grotere merkbekendheid of een scherpere digitale marketingstrategie. We delen tijdens de strategiesessies inzichten over de laatste digitale trends en technologieën, zodat je nooit een stap achterloopt. Voor ons is samenwerking geen eenmalige deal, maar een voortdurende reis om samen te blijven groeien in een dynamische digitale wereld.",
            },
            {
                type: 'case',
                case: 'recirculo',
            },
        ],
        related_services: ['customer-journey', 'ux-research', 'design-sprint'],
        contact: {
            title: '',
            employee: 'michiel',
        },
    },
    en: {},
};
